/**
 * Le total HT dont un acompte est un pourcentage, figé à son émission par
 * `emettre_acompte` dans `metadata.acompte.total_ht_origine`.
 *
 * C'est un engagement que le CRM connaît par lui-même, même quand le devis n'a
 * pas été rattaché au chantier — la troisième source, après la fiche chantier
 * et le devis signé.
 *
 * Lu DÉFENSIVEMENT : `metadata` est du jsonb libre, et une valeur inattendue
 * ne doit pas propager un NaN dans les totaux d'un écran. Tout ce qui n'est
 * pas un nombre strictement positif rend null.
 */
export function totalOrigineAcompte(metadata: unknown): number | null {
  if (typeof metadata !== 'object' || metadata === null) return null;
  const acompte = (metadata as { acompte?: unknown }).acompte;
  if (typeof acompte !== 'object' || acompte === null) return null;
  const brut = (acompte as { total_ht_origine?: unknown }).total_ht_origine;
  const n = typeof brut === 'string' || typeof brut === 'number' ? Number(brut) : NaN;
  return Number.isFinite(n) && n > 0 ? n : null;
}
